import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { Loader2, AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function MagicVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const token = new URLSearchParams(location.search).get('token');
      if (!token) { setError('Lien invalide.'); return; }
      try {
        const res = await axios.post(
          `${API_URL}/api/auth/magic/verify`,
          { token },
          { withCredentials: true }
        );
        setUser(res.data);
        const role = res.data.role;
        if (role === 'employee') navigate('/employee', { state: { user: res.data } });
        else navigate('/client', { state: { user: res.data } });
      } catch (e) {
        setError(e.response?.data?.detail || 'Lien invalide ou expiré. Veuillez en demander un nouveau.');
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center px-4">
      <div className="text-center max-w-md" data-testid="magic-verify-page">
        {error ? (
          <>
            <AlertTriangle className="w-12 h-12 text-[#C86B51] mx-auto mb-4" />
            <p className="text-[#2A312C] mb-4" data-testid="magic-verify-error">{error}</p>
            <button className="btn-primary" onClick={() => navigate('/')} data-testid="magic-back-home">
              Retour à l'accueil
            </button>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-[#A5BBA8] mx-auto mb-4" />
            <p className="text-[#5C6A61]">Connexion en cours...</p>
          </>
        )}
      </div>
    </div>
  );
}
